/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Hide_Event_LabelInputs */



/**
* | output |
* | --- |
* | "Hide Event" |
*
* @param {Timing_Sync_Hide_Event_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_hide_event_label = /** @type {((inputs?: Timing_Sync_Hide_Event_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Hide_Event_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Masquer l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis ausblenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nascondi evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скрыть событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ocultar evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("隐藏事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを非表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट छिपाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ocultar evento")
	return /** @type {LocalizedString} */ ("Hide Event")
});